import LuckyDrawDetailForm from "./luckyDrawDetailForm.container";

export default LuckyDrawDetailForm;
